// ABOUTME: Tab configuration for warehouse service desk / support ticket management.
// ABOUTME: Defines tabs for workscreen, open tickets, unassigned tickets, and settings.

import InboxIcon from '@mui/icons-material/Inbox';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import PersonOffIcon from '@mui/icons-material/PersonOff';
import SettingsIcon from '@mui/icons-material/Settings';

export const warehouseRelationServiceSettingsConfig = {

    labels: {
        title: 'labels',
        icon: <InboxIcon/>,
    },
    
};
